import { createContext } from "react";

export const ScaleContext = createContext(1);
